import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Toggle from '/@/components/forms/toggle';
import settings from '/@/core/settings';
import {
    addExtra,
    addFeature,
    addMetric,
    addModule,
    removeExtra,
    removeFeature,
    removeMetric,
    removeModule,
} from '/@/store/product-datasheet/actions';
import {
    getSelectedExtrasIds,
    getSelectedFeaturesIds,
    getSelectedMetricsIds,
    getSelectedModulesIds,
} from '/@/store/product-datasheet/selectors';
import styles from './styles.module.css';

const features = 'features';
const metrics = 'metrics';
const extras = 'extras';

@connect(
    (state, props) => {
        return {
            modulesIds: getSelectedModulesIds(state),
            featuresIds: getSelectedFeaturesIds(state),
            metricsIds: getSelectedMetricsIds(state),
            extrasIds: getSelectedExtrasIds(state, props),
        };
    },
    (dispatch) =>
        bindActionCreators(
            {
                addModule,
                removeModule,
                addFeature,
                removeFeature,
                addMetric,
                removeMetric,
                addExtra,
                removeExtra,
            },
            dispatch
        )
)
@autobind
export default class Modules extends Component {
    static propTypes = {
        options: PropTypes.any,
        type: PropTypes.oneOf(['modules', 'features', 'metrics', 'extras']),
    };

    componentDidMount() {
        const { type, addFeature, addMetric, featuresIds, metricsIds } = this.props;
        if (type === features && featuresIds.length === 0) this.compareSelecteds(features, addFeature);
        if (type === metrics && metricsIds.length === 0) this.compareSelecteds(metrics, addMetric);
        if (type === 'modules') {
            this.handleToggle('densities', 'densities');
        }
    }

    componentDidUpdate(prevProps) {
        const { type, addFeature, addMetric, options } = this.props;
        if (type === features && this.compareOptions(prevProps.options, options))
            this.compareSelecteds(features, addFeature);
        if (type === metrics && this.compareOptions(prevProps.options, options))
            this.compareSelecteds(metrics, addMetric);
    }

    compareOptions(prevOptions, options) {
        return options.some((opt) => prevOptions.every((popt) => opt.key !== popt.key));
    }

    compareSelecteds(typeModule, addModule) {
        const { type, options } = this.props;
        options.forEach((opt) => {
            if (type === typeModule && this.props[`${typeModule}Ids`].indexOf(opt.key) === -1) {
                addModule(opt.key);
            }
        });
    }

    handleToggle(value, id) {
        const {
            type,
            addFeature,
            removeFeature,
            addMetric,
            removeMetric,
            addExtra,
            removeExtra,
            addModule,
            removeModule,
        } = this.props;
        if (type === features) return value ? addFeature(id) : removeFeature(id);
        if (type === metrics) return value ? addMetric(id) : removeMetric(id);
        if (type === extras) return value ? addExtra(id) : removeExtra(id);
        return value ? addModule(id) : removeModule(id);
    }

    render() {
        if (!this.props.options.length) return null;

        return (
            <div className={styles.root}>
                {this.props.options.map((module) => (
                    <div className={styles.item} key={module.key}>
                        <Toggle
                            theme={settings.app.theme}
                            type='checkbox'
                            label={module.name}
                            value={this.props[`${this.props.type}Ids`].includes(module.key)}
                            onChange={(value) => this.handleToggle(value, module.key)}
                        />
                    </div>
                ))}
            </div>
        );
    }
}
